import clsx from 'clsx';
import { getPersonName } from '../config/personNames';

export type Scope = 'household' | 'dakota' | 'natalia';

export function ScopeToggle({
  value,
  onChange,
}: {
  value: Scope;
  onChange: (next: Scope) => void;
}) {
  // Built per render so demo-mode label swaps take effect after the user
  // unlocks with the demo password (no full reload required).
  const options: { value: Scope; label: string; dot?: 'dakota' | 'natalia' }[] = [
    { value: 'household', label: 'Household' },
    { value: 'dakota', label: getPersonName('dakota'), dot: 'dakota' },
    { value: 'natalia', label: getPersonName('natalia'), dot: 'natalia' },
  ];
  return (
    <div className="scope-toggle" role="tablist">
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={clsx('scope-toggle-btn', active && 'scope-toggle-btn-active')}
          >
            {opt.dot && (
              <span
                className={`person-dot ${opt.dot === 'dakota' ? 'dot-dakota' : 'dot-natalia'}`}
              />
            )}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
